export function dtDialog(option){
  var el=option.el;
  var shade=document.createElement("div");
  var i;
  //设置shade和el的css
  var shadeCss={
    display:"none",
    position:"fixed",
    top:"0",
    left:"0",
    height:"100%",
    width:"100%",
    background:"rgba(0,0,0,0.5)"
  }
  for(i in shadeCss){
    shade.style[i]=shadeCss[i];
  }
  var elCss={
    position:"absolute",
    left:"50%",
    top:"50%",
    transform:"translate(-50%,-50%)"
  }
  for(i in elCss){
    el.style[i]=elCss[i];
  }
  shade.appendChild(el);
  document.body.appendChild(shade);

  //路由改变时，删掉对话框
  var removeShade=function(){
      document.body.removeChild(shade);
    window.removeEventListener("hashchange",removeShade);
  }
  window.addEventListener("hashchange",removeShade);

  var Dialog=function(){

  }
  Dialog.prototype.close=function(){
    shade.style.display="none";
  }
  Dialog.prototype.open=function(){
    shade.style.display="";
  }
  return new Dialog();
}



// WEBPACK FOOTER //
// ./src/util/dialog/index.js